import { Footer } from "../../footer/Footer";
import { TopMenu } from "../../top-menu/TopMenu";
import Banner from '../../../assets/model_banner.png';
import AISC from '../../../assets/aisc.png';
import NISD from '../../../assets/nisd.png';

export const HomeWrapper = () => (
    <div className="min-h-screen flex flex-col bg-black text-white">
        <TopMenu />
        <main className="flex-1 py-10 px-5">
            <div className="flex justify-center items-center mb-10">
                <img src={Banner} alt="Banner" className="w-full max-w-4xl" />
            </div>
            <div className="flex flex-col md:flex-row gap-5">
                <div className="flex-1">
                    <h1 className="font-bold">
                        Rocky Point Detailing, LLC<br />
                        &amp; Aircad, LLC
                    </h1>
                    <p className="font-bold">
                        Are a structural steel and miscellaneous metals detailing firm having
                        provided quality accurate shop drawings to steel fabricators since 1993.
                    </p>
                </div>
                <div className="text-center">
                    <h1 className="text-accent">Memberships</h1>
                    <div className="flex justify-center items-center gap-8">
                        <img src={AISC} alt="AISC" className="w-36" />
                        <img src={NISD} alt="NISD" className="w-36 invert" />
                    </div>
                </div>
            </div>
        </main>
        <Footer />
    </div>
);
